export default {
  data() {
    return {
      show: false,
    };
  },

  methods: {
    showModal: showModal,
    close: close,
  },

  mounted() {
    this.$eventBus.$on("show-landing-modal", this.showModal);
  },

  beforeDestroy() {
    this.$eventBus.$off("show-landing-modal");
  },
};

function showModal() {
  this.show = true;
}

function close() {
  this.show = false;
  localStorage.setItem("IS_LANDING_MODAL_SHOWN", "true");
}
